import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { capitalizeString } from './helpers';

const styles = theme => ({

});

class PageHeader extends React.Component {
    render() {
        const { component_type, component_name, view_type } = this.props;
        
        return (
            <div className="p-24">
                <h4>{capitalizeString(component_type) + " " + capitalizeString(view_type)}</h4>
                {typeof view_type === 'undefined' || view_type === 'edit' || view_type === 'detail' ? 
                    <h4>{component_name}</h4>
                : null}
            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(PageHeader);


// WEBPACK FOOTER //
// src/main/components/PageHeader.js